import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material/styles';
import AuthContext from "./auth/Context";
import Box from '@mui/material/Box';

const ToolbarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  
  // --- TĂNG KHOẢNG CÁCH GIỮA CÁC NÚT (GAP) ---
  gap: theme.spacing(1.5), 
  
  // --- TĂNG PADDING GIỮA CÁC NÚT VÀ CONTAINER ---
  // 1 = 8px (trên/dưới), 2.5 = 20px (trái/phải)
  padding: theme.spacing(1, 2.5), 
  
  zIndex: theme.zIndex.appBar + 2,

  width: 'fit-content',
  maxWidth: 'calc(100vw - 32px)',
  
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius * 50,
  background: alpha(
    theme.palette.mode === 'light' 
      ? theme.palette.grey[100] 
      : theme.palette.grey[900],
    0.75
  ),
  border: `1px solid ${alpha(theme.palette.grey[500], 0.2)}`,
  backdropFilter: 'saturate(180%) blur(20px)',
  WebkitBackdropFilter: 'saturate(180%) blur(20px)',
  boxShadow: 'none',

  // 1. STYLE CHO ICON BUTTON (HÌNH TRÒN TUYỆT ĐỐI 1:1)
  '& .MuiIconButton-root': {
    width: '56px !important', 
    height: '56px !important',   
    flex: '0 1 auto !important', 
    aspectRatio: '1 / 1',        
    padding: '0 !important',
    margin: '0 !important',
    borderRadius: '50% !important',
    minWidth: 0, 

    '& .MuiSvgIcon-root': {
      fontSize: '0 !important', 
      width: '60% !important',   
      height: '60% !important',  
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },

    '& .MuiAvatar-root': {
      width: '100% !important',
      height: '100% !important',
    }
  },

  // 2. STYLE CHO BUTTON THƯỜNG (HÌNH VIÊN THUỐC - PILL SHAPE)
  '& .MuiButton-root': {
    height: '56px !important', // Đồng bộ chiều cao với IconButton
    flex: '0 1 auto !important', 
    padding: '0 24px !important', 
    margin: '0 !important',
    borderRadius: '50px !important', // Tạo hình viên thuốc
    minWidth: 'auto',
    whiteSpace: 'nowrap', 
    fontWeight: 600, 
  },

  // 3. Xử lý Tooltip wrapper (Khi các nút được bọc trong Tooltip/Box)
  '& > span, & > div': {
     display: 'flex',
     flex: '0 1 auto', 
     justifyContent: 'center',
     alignItems: 'center', 
     
     '& .MuiIconButton-root': {
        width: '56px !important',
        height: '56px !important',
     },
     '& .MuiButton-root': {
        height: '56px !important',
     }
  }
}));

const Toolbar = ({ children, position = 'bottom', margin = (window.ReactNativeWebView ||  window.matchMedia('(display-mode: standalone)').matches) ? 16 : 5 }) => {
  let pb = `${margin}px`;
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
      pointerEvents: 'none',
      zIndex: 1300
    }}>
      <ToolbarContainer
        sx={{
          marginTop: position === 'top' ? `${margin}px` : 0,
          marginBottom: position === 'bottom' ? pb : 0,
          pointerEvents: 'auto',
        }}
      >
        {children}
      </ToolbarContainer>
    </div>
  );
};

Toolbar.propTypes = {
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['top', 'bottom']),
  margin: PropTypes.number,
};

export default Toolbar;